import React from "react";

const SavingsBanner = ({ saved }) => {
  return saved !== 0 ? (
    <div className="d-flex align-items-center transition bg-white cartSavingsBanner">
      <div className="w-100 my-auto overflow-hidden">
        <h2>{`₹${saved} savings`}</h2>
        <h5>Wow! Savings with Rashan Point 😇</h5>
      </div>
    </div>
  ) : null;
};

export default SavingsBanner;
